import { render, staticRenderFns } from "./EmptyBasket.vue?vue&type=template&id=3c9c1dde&scoped=true&"
import script from "./EmptyBasket.vue?vue&type=script&lang=js&"
export * from "./EmptyBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9c1dde",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/empty_basket.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fbasket%2FEmptyBasket.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports